import { onBeforeUnmount, onMounted } from 'vue'

/**
 * Colours the document root behind the dark valuation pages so browser chrome
 * and overscroll areas blend with the page. No theme-color meta is used —
 * with viewport-fit=cover, iOS Safari tints its bars from the page content
 * behind them, which keeps the status bar matching the gradient exactly.
 *
 * @param {'solid'|'split'} variant
 *   'solid' — dark behind the whole page (capture flow)
 *   'split' — dark behind the top, white behind the bottom (hub page, which
 *             ends in a white content card)
 */
export function useDarkPage(variant = 'solid') {
  onMounted(() => {
    document.documentElement.classList.add('page-dark')
    if (variant === 'split') {
      document.documentElement.classList.add('page-dark-split')
    }
  })

  onBeforeUnmount(() => {
    document.documentElement.classList.remove('page-dark', 'page-dark-split')
  })
}
